import { Component, EventEmitter, Input, Output } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';

@Component({
    selector: 'app-map-tools-panel',
    templateUrl: './map-tools-panel.component.html',
    styleUrls: ['./map-tools-panel.component.scss'],
    animations: [
        trigger('slideInOut', [
            state('hidden', style({
                transform: 'translateX(100%)',
                display: 'none'
            })),
            state('visible', style({
                transform: 'translateX(0)',
                display: 'block'
            })),
            transition('hidden => visible', [
                style({ display: 'block' }),
                animate('200ms ease-in-out')
            ]),
            transition('visible => hidden', [
                animate('0ms ease-in-out', style({ transform: 'translateX(100%)' })),
                style({ display: 'none' })
            ])
        ])
    ]
})
export class MapToolsPanelComponent {
    @Input() slideState: string = 'hidden';
    @Input() zIndex: number = 50;
    @Input() loadingMap: boolean = false;

    @Input() isSuperAdmin: boolean = false;
    @Input() squadGalleryList: any[] = [];
    @Input() investigatorsCombined: any[] = [];
    @Input() baseStations: any[] = [];
    @Input() sites: any[] = [];
    @Input() caseId: string | undefined;
    @Input() isInvestigator: boolean = false;
    @Input() isBaseStationFilterOn: boolean = true;
    @Input() platesOfInterestDisplay: any[] = [];
    @Input() peopleOfInterestDisplay: any[] = [];
    @Input() enableSiteMapping: boolean = false;
    @Input() safeRoutes: any[] = [];

    /** Parent-bound predicate so `this` stays correct (e.g. `(u) => this.hasTeammemberMarker(u)`). */
    @Input() showTeammemberLocate?: (user: any) => boolean;

    @Output() closed = new EventEmitter<void>();
    @Output() openGallery = new EventEmitter<void>();
    @Output() addPersonOfInterest = new EventEmitter<void>();
    @Output() addCarOfInterest = new EventEmitter<void>();
    @Output() squadDragStart = new EventEmitter<{ event: DragEvent; squad: any }>();
    @Output() investigatorDragStart = new EventEmitter<{ event: DragEvent; user: any }>();
    @Output() logTeammemberMarkers = new EventEmitter<{ event: MouseEvent; userId: string }>();
    @Output() addAntennaBasedLocation = new EventEmitter<void>();
    @Output() editAntennaBasedLocation = new EventEmitter<any>();
    @Output() locateAreaInterestOutput = new EventEmitter<any>();
    @Output() toggleBaseStations = new EventEmitter<any>();
    /** Row reference + `checked` so parents can sync `[checked]` / `isChecked` with the map. */
    @Output() plateToggle = new EventEmitter<{ plate: any; checked: boolean }>();
    @Output() personToggle = new EventEmitter<{ person: any; checked: boolean }>();
    @Output() selectInterestNote = new EventEmitter<any>();
    @Output() addSite = new EventEmitter<void>();
    @Output() selectSite = new EventEmitter<any>();
    @Output() selectSafeRoute = new EventEmitter<any>();

    searchTerm: string = '';

    get filteredInvestigators() {
        if (!this.searchTerm) {
            return this.investigatorsCombined;
        }
        const term = this.searchTerm.toLowerCase();
        return this.investigatorsCombined.filter(user => {
            const name = (user.alternative_name || user.name || '').toLowerCase();
            return name.includes(term);
        });
    }

    showLocate(user: any): boolean {
        return this.showTeammemberLocate ? this.showTeammemberLocate(user) : false;
    }

    trackById(index: number, item: any): string | number {
        return item?._id || item?.id || item?.name || index;
    }

    trackByInterest(index: number, item: any): string | number {
        return item?._id || item?.plate_of_interest || item?.car_of_interest_identifier || item?.person_of_interest_name || index;
    }
}
